export default __webpack_public_path__ + "static/media/IMG-20240708-WA0028.335c7de8.jpg";